import { SAVE_FILE, FETCH_FILES, FETCH_EXERCISE_VIDEOS, RESET_FILES } from "../actionTypes"
import axios from 'axios';
import { showLoader, hideLoader } from './loader';
import { showAlert } from "./alert"

const SERVICE = 'files';

export const saveFile = fileMeta => (dispatch, getState) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  dispatch(showLoader());
  return new Promise((respond,rej) => {
    return axios.post(SERVICE, fileMeta)
      .then(res => {
        dispatch(hideLoader());
        dispatch({
          type: SAVE_FILE,
          payload: {
            data: res.data
          }
        });
        respond(res.data);
      }).catch(function (err) {
        dispatch(hideLoader());
        if (err.response) {
          dispatch(showAlert(err.response.data.error.message, true));
        }
        rej();
      });
  })

}

export const fetchInfo = (id) => (dispatch) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  return new Promise(function(resolve, reject) {
    const url = `${SERVICE}/${id}`
    axios.get(SERVICE, { params: {
      _id: id
    }}).then(res => {
        dispatch(hideLoader());
        resolve(res.data);
    });
  });
}

export const fetchFiles = (query) => (dispatch) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  if (query.skip === 0) {
    dispatch(showLoader());
  }
  if (!query.userId) return;
  return new Promise(function(resolve, reject) {
    axios.get(SERVICE, { params: query }).then(res => {
      dispatch(hideLoader());
      dispatch({
        type: FETCH_FILES,
        payload: {
          data: res.data,
        }
      });
      resolve();
    });
  });
}

export const resetFiles = () => dispatch => {
	dispatch({
		type: RESET_FILES,
	});
};



export const fetchExerciseVideos = (userId) => (dispatch) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  dispatch(showLoader());
  axios.get(SERVICE, {params: {
    category: 'exercise',
    userId: userId
  }}).then(res => {
    dispatch(hideLoader());
    return dispatch({
      type: FETCH_EXERCISE_VIDEOS,
      payload: res.data
    });
  });
}



// WEBPACK FOOTER //
// ./src/store/actions/files.js